/* eslint-disable no-param-reassign */
import type { ShortUrlEntry, ShortUrlInfo, ShortUrlsCacheState } from './types';

// mutations are mutating the state contents to conserve the reference and avoid triggering unnecessary re-renders
// although we're still returning a new state reference to trigger the react lifecycle
export const mutations = {
	addToQueue: (state: ShortUrlsCacheState, entries: readonly ShortUrlEntry[]): ShortUrlsCacheState => {
		const filteredEntries = entries.filter(
			(entry) => !state.cache[entry.longUrl] && !state.queue.includes(entry.longUrl),
		);
		filteredEntries.forEach((entry) => {
			state.cache[entry.longUrl] = {
				status: 'loading',
				localShareId: entry.localShareId,
				normalizedLongUrl: entry.normalizedLongUrl,
			};
		});

		if (!filteredEntries.length) return state;

		state.queue.push(...filteredEntries.map((entry) => entry.longUrl));

		return { ...state };
	},
	removeFromQueue: (state: ShortUrlsCacheState, configs: readonly string[]): ShortUrlsCacheState => {
		if (!state.queue.length || !configs.length) return state;

		configs.forEach((config) => {
			const index = state.queue.indexOf(config);
			if (index === -1) return;
			state.queue.splice(index, 1);
		});

		return { ...state };
	},
	setLoaded: (state: ShortUrlsCacheState, infos: Record<string, ShortUrlInfo>): ShortUrlsCacheState => {
		if (!Object.keys(infos).length) return state;

		Object.entries(infos).forEach(([longUrl, info]) => {
			state.cache[longUrl] = { status: 'loaded', info };
		});

		return { ...state };
	},
	setError: (state: ShortUrlsCacheState, entries: readonly ShortUrlEntry[]): ShortUrlsCacheState => {
		if (!entries.length) return state;

		entries.forEach((entry) => {
			state.cache[entry.longUrl] = {
				status: 'error',
				localShareId: entry.localShareId,
				normalizedLongUrl: entry.normalizedLongUrl,
			};
		});

		return { ...state };
	},
};
